function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDevWeb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 750 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-simple--inject-119"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M632.12,129.44S529.34,24.18,395.77,16.05,184.31,94.21,147.4,145.67s-129,137.2-118.14,215.71S146.59,499.46,299.11,473.29s196.74-36.1,266.23-16.24,159.74-9.93,161.54-122.74S632.12,129.44,632.12,129.44Z",
    style: {
      fill: "#6C63FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M632.12,129.44S529.34,24.18,395.77,16.05,184.31,94.21,147.4,145.67s-129,137.2-118.14,215.71S146.59,499.46,299.11,473.29s196.74-36.1,266.23-16.24,159.74-9.93,161.54-122.74S632.12,129.44,632.12,129.44Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-119"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 34.42,
    y1: 427.31,
    x2: 713.74,
    y2: 427.31,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Tabs--inject-119"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M521,268.13H625.1a0,0,0,0,1,0,0v99.66a6.06,6.06,0,0,1-6.06,6.06h-92a6.06,6.06,0,0,1-6.06-6.06V268.13A0,0,0,0,1,521,268.13Z",
    transform: "translate(1146.14 641.97) rotate(180)",
    style: {
      fill: "#fff",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M521,268.13H625.1a0,0,0,0,1,0,0v7.76a6.06,6.06,0,0,1-6.06,6.06h-92a6.06,6.06,0,0,1-6.06-6.06v-7.76A0,0,0,0,1,521,268.13Z",
    transform: "translate(1146.14 550.07) rotate(180)",
    style: {
      fill: "#fff",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 608.41,
    cy: 298.23,
    r: 8.19,
    style: {
      fill: "#fff",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 603.73,
    y: 316.15,
    width: 12.89,
    height: 3.74,
    transform: "translate(1220.35 636.04) rotate(180)",
    style: {
      fill: "#fff",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 603.73,
    y: 329.73,
    width: 12.89,
    height: 3.74,
    transform: "translate(1220.35 663.2) rotate(180)",
    style: {
      fill: "#fff",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 603.73,
    y: 343.3,
    width: 12.89,
    height: 3.74,
    transform: "translate(1220.35 690.35) rotate(180)",
    style: {
      fill: "#fff",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 603.73,
    y: 356.73,
    width: 12.89,
    height: 3.74,
    transform: "translate(1220.35 717.21) rotate(180)",
    style: {
      fill: "#fff",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 528.8,
    y: 288.28,
    width: 63.8,
    height: 21.07,
    transform: "translate(1121.41 597.64) rotate(180)",
    style: {
      fill: "#fff",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 531.86,
    y: 314.81,
    width: 59.33,
    height: 29.66,
    transform: "translate(1123.05 659.29) rotate(180)",
    style: {
      fill: "#fff",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "591.19 344.48 570.49 332.73 559.98 335.82 543.6 322.84 532.17 330.26 532.17 344.48 591.19 344.48",
    style: {
      fill: "#fff",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M575.43,324.39a4.64,4.64,0,1,0,4.63-4.64A4.63,4.63,0,0,0,575.43,324.39Z",
    style: {
      fill: "#fff",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 573.41,
    y1: 350.79,
    x2: 529.23,
    y2: 350.79,
    style: {
      fill: "#fff",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 591.88,
    y1: 350.79,
    x2: 576.41,
    y2: 350.79,
    style: {
      fill: "#fff",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 542.77,
    y1: 356.68,
    x2: 529.23,
    y2: 356.68,
    style: {
      fill: "#fff",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 577.62,
    y1: 356.68,
    x2: 546.67,
    y2: 356.68,
    style: {
      fill: "#fff",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 591.88,
    y1: 356.68,
    x2: 580.92,
    y2: 356.68,
    style: {
      fill: "#fff",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 563.2,
    y1: 362.58,
    x2: 529.23,
    y2: 362.58,
    style: {
      fill: "#fff",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 591.88,
    y1: 362.58,
    x2: 566.8,
    y2: 362.58,
    style: {
      fill: "#fff",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 541.27,
    y1: 368.47,
    x2: 529.23,
    y2: 368.47,
    style: {
      fill: "#fff",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 583.92,
    y1: 368.47,
    x2: 544.27,
    y2: 368.47,
    style: {
      fill: "#fff",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 591.88,
    y1: 368.47,
    x2: 587.23,
    y2: 368.47,
    style: {
      fill: "#fff",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M495.32,287.56H599.38a0,0,0,0,1,0,0v99.66a6.06,6.06,0,0,1-6.06,6.06h-92a6.06,6.06,0,0,1-6.06-6.06V287.56A0,0,0,0,1,495.32,287.56Z",
    transform: "translate(1094.7 680.83) rotate(180)",
    style: {
      fill: "#fff",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M495.32,287.56H599.38a0,0,0,0,1,0,0v7.76a6.06,6.06,0,0,1-6.06,6.06h-92a6.06,6.06,0,0,1-6.06-6.06v-7.76A0,0,0,0,1,495.32,287.56Z",
    transform: "translate(1094.7 588.93) rotate(180)",
    style: {
      fill: "#fff",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 582.69,
    cy: 317.66,
    r: 8.19,
    transform: "translate(67.08 735.5) rotate(-67.62)",
    style: {
      fill: "#fff",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 578.01,
    y: 335.58,
    width: 12.89,
    height: 3.74,
    transform: "translate(1168.91 674.9) rotate(180)",
    style: {
      fill: "#fff",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 578.01,
    y: 349.16,
    width: 12.89,
    height: 3.74,
    transform: "translate(1168.91 702.06) rotate(180)",
    style: {
      fill: "#fff",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 578.01,
    y: 362.74,
    width: 12.89,
    height: 3.74,
    transform: "translate(1168.91 729.21) rotate(180)",
    style: {
      fill: "#fff",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 578.01,
    y: 376.16,
    width: 12.89,
    height: 3.74,
    transform: "translate(1168.91 756.07) rotate(180)",
    style: {
      fill: "#fff",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 503.08,
    y: 307.71,
    width: 63.8,
    height: 21.07,
    transform: "translate(1069.97 636.5) rotate(180)",
    style: {
      fill: "#fff",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 506.14,
    y: 334.24,
    width: 59.33,
    height: 29.67,
    transform: "translate(1071.61 698.15) rotate(180)",
    style: {
      fill: "#fff",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "565.47 363.91 544.76 352.16 534.26 355.25 517.88 342.28 506.45 349.69 506.45 363.91 565.47 363.91",
    style: {
      fill: "#fff",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M549.71,343.82a4.64,4.64,0,1,0,4.63-4.63A4.63,4.63,0,0,0,549.71,343.82Z",
    style: {
      fill: "#fff",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 547.69,
    y1: 370.22,
    x2: 503.51,
    y2: 370.22,
    style: {
      fill: "#fff",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 566.16,
    y1: 370.22,
    x2: 550.69,
    y2: 370.22,
    style: {
      fill: "#fff",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 517.05,
    y1: 376.12,
    x2: 503.51,
    y2: 376.12,
    style: {
      fill: "#fff",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 551.9,
    y1: 376.12,
    x2: 520.95,
    y2: 376.12,
    style: {
      fill: "#fff",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 566.16,
    y1: 376.12,
    x2: 555.2,
    y2: 376.12,
    style: {
      fill: "#fff",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 537.48,
    y1: 382.01,
    x2: 503.51,
    y2: 382.01,
    style: {
      fill: "#fff",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 566.16,
    y1: 382.01,
    x2: 541.08,
    y2: 382.01,
    style: {
      fill: "#fff",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 515.55,
    y1: 387.91,
    x2: 503.51,
    y2: 387.91,
    style: {
      fill: "#fff",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 558.2,
    y1: 387.91,
    x2: 518.55,
    y2: 387.91,
    style: {
      fill: "#fff",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 566.16,
    y1: 387.91,
    x2: 561.51,
    y2: 387.91,
    style: {
      fill: "#fff",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M469.59,307H573.66a0,0,0,0,1,0,0v99.66a6.06,6.06,0,0,1-6.06,6.06h-92a6.06,6.06,0,0,1-6.06-6.06V307A0,0,0,0,1,469.59,307Z",
    transform: "translate(1043.26 719.69) rotate(180)",
    style: {
      fill: "#fff",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M469.59,307H573.66a0,0,0,0,1,0,0v7.76a6.06,6.06,0,0,1-6.06,6.06h-92a6.06,6.06,0,0,1-6.06-6.06V307A0,0,0,0,1,469.59,307Z",
    transform: "translate(1043.26 627.79) rotate(180)",
    style: {
      fill: "#fff",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 556.97,
    cy: 337.1,
    r: 8.19,
    style: {
      fill: "#fff",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 552.29,
    y: 355.01,
    width: 12.89,
    height: 3.74,
    transform: "translate(1117.46 713.76) rotate(180)",
    style: {
      fill: "#fff",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 552.29,
    y: 368.59,
    width: 12.89,
    height: 3.74,
    transform: "translate(1117.46 740.92) rotate(180)",
    style: {
      fill: "#fff",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 552.29,
    y: 382.17,
    width: 12.89,
    height: 3.74,
    transform: "translate(1117.46 768.08) rotate(180)",
    style: {
      fill: "#fff",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 552.29,
    y: 395.59,
    width: 12.89,
    height: 3.74,
    transform: "translate(1117.46 794.93) rotate(180)",
    style: {
      fill: "#fff",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 477.36,
    y: 327.14,
    width: 63.8,
    height: 21.07,
    transform: "translate(1018.53 675.36) rotate(180)",
    style: {
      fill: "#fff",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 480.42,
    y: 353.67,
    width: 59.33,
    height: 29.66,
    transform: "translate(1020.17 737.01) rotate(180)",
    style: {
      fill: "#fff",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "539.75 383.34 519.04 371.6 508.54 374.69 492.16 361.71 480.73 369.12 480.73 383.34 539.75 383.34",
    style: {
      fill: "#fff",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M524,363.25a4.64,4.64,0,1,0,4.63-4.63A4.63,4.63,0,0,0,524,363.25Z",
    style: {
      fill: "#fff",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 521.97,
    y1: 389.65,
    x2: 477.79,
    y2: 389.65,
    style: {
      fill: "#fff",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 540.44,
    y1: 389.65,
    x2: 524.97,
    y2: 389.65,
    style: {
      fill: "#fff",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 491.33,
    y1: 395.55,
    x2: 477.79,
    y2: 395.55,
    style: {
      fill: "#fff",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 526.17,
    y1: 395.55,
    x2: 495.23,
    y2: 395.55,
    style: {
      fill: "#fff",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 540.44,
    y1: 395.55,
    x2: 529.48,
    y2: 395.55,
    style: {
      fill: "#fff",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 511.76,
    y1: 401.44,
    x2: 477.79,
    y2: 401.44,
    style: {
      fill: "#fff",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 540.44,
    y1: 401.44,
    x2: 515.36,
    y2: 401.44,
    style: {
      fill: "#fff",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 489.83,
    y1: 407.34,
    x2: 477.79,
    y2: 407.34,
    style: {
      fill: "#fff",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 532.48,
    y1: 407.34,
    x2: 492.83,
    y2: 407.34,
    style: {
      fill: "#fff",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 540.44,
    y1: 407.34,
    x2: 535.79,
    y2: 407.34,
    style: {
      fill: "#fff",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Gears--inject-119"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M137.16,93.87V83.42l-10.44-1.16A24.7,24.7,0,0,0,124.16,76l6.6-8.24-7.39-7.39L115.16,67a24.94,24.94,0,0,0-6.2-2.59l-1.17-10.49H97.34L96.18,64.32A24.48,24.48,0,0,0,90,66.88l-8.25-6.6-7.39,7.4,6.57,8.2a24.88,24.88,0,0,0-2.6,6.21L67.8,83.25V93.7l10.44,1.16a24.7,24.7,0,0,0,2.56,6.23l-6.59,8.24,7.39,7.39,8.21-6.57a24.44,24.44,0,0,0,6.2,2.6l1.16,10.49h10.46l1.16-10.44a24.78,24.78,0,0,0,6.22-2.56l8.24,6.6,7.39-7.4-6.56-8.2a24.88,24.88,0,0,0,2.6-6.21ZM102.48,101A12.47,12.47,0,1,1,115,88.56,12.47,12.47,0,0,1,102.48,101Z",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.24,72.89,177.08,66l-7,.39a16.62,16.62,0,0,0-2.39-3.84l3.46-6.19-5.72-4.07-4.7,5.25a17.11,17.11,0,0,0-4.4-1l-1.93-6.81-6.92,1.16.39,7A16.58,16.58,0,0,0,144,60.25L137.8,56.8l-4.07,5.71L139,67.22a16.65,16.65,0,0,0-1,4.39l-6.81,1.94,1.16,6.91,7-.38a16.73,16.73,0,0,0,2.38,3.83l-3.45,6.19L144,94.17l4.71-5.25a16.63,16.63,0,0,0,4.39,1L155,96.76l6.92-1.15-.39-7a16.55,16.55,0,0,0,3.83-2.39l6.19,3.45,4.07-5.71-5.25-4.7a16.7,16.7,0,0,0,1-4.4Zm-22.17,8.58A8.37,8.37,0,1,1,163,71.83,8.36,8.36,0,0,1,156.07,81.47Z",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M242,390.19V379.74l-10.43-1.16a25.23,25.23,0,0,0-2.56-6.22l6.59-8.25-7.39-7.39L220,363.29a25,25,0,0,0-6.2-2.6l-1.17-10.49H202.17L201,360.64a24.63,24.63,0,0,0-6.22,2.56l-8.24-6.59-7.4,7.39,6.57,8.21a24.81,24.81,0,0,0-2.6,6.2l-10.49,1.16V390l10.44,1.16a25,25,0,0,0,2.56,6.22L179,405.65l7.39,7.39,8.21-6.56a25,25,0,0,0,6.2,2.6L202,419.56h10.45l1.16-10.44a25,25,0,0,0,6.22-2.55l8.24,6.59,7.39-7.39-6.56-8.21a25,25,0,0,0,2.6-6.2Zm-34.68,7.17a12.48,12.48,0,1,1,12.48-12.48A12.47,12.47,0,0,1,207.31,397.36Z",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.07,369.21l-1.16-6.92-7,.39a16.79,16.79,0,0,0-2.38-3.84l3.45-6.18-5.72-4.08-4.7,5.26a16.72,16.72,0,0,0-4.4-1L259.19,346l-6.92,1.16.39,7a16.79,16.79,0,0,0-3.84,2.38l-6.18-3.45-4.08,5.71,5.26,4.71a16.65,16.65,0,0,0-1,4.39L236,369.87l1.16,6.92,7-.39a16.52,16.52,0,0,0,2.38,3.83l-3.45,6.19,5.71,4.08,4.71-5.26a16.25,16.25,0,0,0,4.39,1l1.94,6.82,6.92-1.16-.39-7a16.52,16.52,0,0,0,3.83-2.38L276.4,386l4.08-5.71-5.26-4.71a16.32,16.32,0,0,0,1-4.4ZM260.9,377.8a8.37,8.37,0,1,1,6.88-9.64A8.38,8.38,0,0,1,260.9,377.8Z",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-119"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51.2,215.8s-4,11.08-12.59,12.59-23.67-15.11-14.1-23.67S47.17,209.76,51.2,215.8Z",
    style: {
      fill: "#6C63FF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.29,161.41s-12.59,30.72-7.55,45.83,36.26,26.19,45.32,6.55S91,166.45,83.43,160.41,66.81,156.38,64.29,161.41Z",
    style: {
      fill: "#6C63FF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.82,174.51s-21.66,19.64-24.18,39.28,12.09,26.69,27.2,24.17S163.5,197.17,159,179.54,137.82,174.51,137.82,174.51Z",
    style: {
      fill: "#6C63FF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.85,283.28s-24.18,1-25.18,12.59,10.57,14.1,22.15,4S151.92,283.79,141.85,283.28Z",
    style: {
      fill: "#6C63FF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.92,307.46s-2.52,12.08-11.58,16.61-25.18-5-16.62-19.64S77.39,301.41,81.92,307.46Z",
    style: {
      fill: "#6C63FF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.77,269.69s-4.54-10.08-22.16-3.53S13.93,282.78,25,286.31,60.77,269.69,60.77,269.69Z",
    style: {
      fill: "#6C63FF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.13,148.82s3,7.05,9.06,5.54,7.55-10.57,17.12-8.05,17.63,13.59,17.63,8.56-12.09-18.13-25.68-18.13S111.63,142.28,111.13,148.82Z",
    style: {
      fill: "#6C63FF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.21,224.89S96.75,255.74,99,282.08s0,68.48,0,68.48",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.09,235.42s-12,35.37-15,58-3.77,57.19-3.77,57.19",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.07,298.63s-5.27,1.51-8.28,52.68",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.92,307.46s5-4.31,8.06,5.47,1.5,36.87,1.5,36.87",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.94,302.61c3.94,22.06.3,46.44.3,46.44",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.77,269.69s21.68-4.17,30.71,19.91A65,65,0,0,1,93.74,297",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.27,246.36s4.53-10.07,22.15-3.53S198.1,259.45,187,263,151.27,246.36,151.27,246.36Z",
    style: {
      fill: "#6C63FF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132,250.77c-4.36,3-8.55,7.8-11.44,15.51-9,24.08-8,83.52-8,83.52",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.27,246.36a28,28,0,0,0-15,2",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75,231.16a71.44,71.44,0,0,1,12.77,23.08c12,34.61,16.55,79,14.3,95.56",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.2,215.8s10.5,1.64,21.13,12.49",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.53,263.56c-.74,43.68-1.26,87-1.26,87",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.13,148.82s-2.34-2.19-3.85,36.94c-.58,15.2-1.17,43.48-1.66,72.36",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.38,427.31h-49a6.53,6.53,0,0,1-6.5-5.89l-7-72.37h76l-7,72.37A6.52,6.52,0,0,1,128.38,427.31Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "68.16 372.38 68.97 380.65 138.83 380.65 139.63 372.38 68.16 372.38",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "137.07 398.71 137.51 394.2 70.28 394.2 70.72 398.71 137.07 398.71",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 131.36,
    cy: 362.6,
    r: 6.02,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.18,368.62a6,6,0,1,0-6-6A6,6,0,0,0,77.18,368.62Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.22,362.6a6,6,0,1,0,6-6A6,6,0,0,0,89.22,362.6Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 113.3,
    cy: 362.6,
    r: 6.02,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-119"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M622.76,272.94s-2.57,36.57.93,53.81,10,61,11.65,65.93,3.26,23.53,3.26,23.53-3.73-.7-3.73,1.39-.23,4-.23,4.9-1.4,3.49-5.83,9.31-10.48,7.69-10,10.25,6.29,4,12.11,3.5,10-.7,13.28-4,7.92-4.19,10.25-5.36,2.79-3.26,2.79-7.69,0-13.28-.23-14.67.23-1.87-.7-7.46S653,343.76,653,343.76s7,45.19,9.55,52.18,4.89,16.77,4.89,16.77-1.39,4,0,6.52,4.9,9.09,4.9,9.09,1.63,10,2.56,14.91,8.15,9.55,10.48,7.92,6.76-5.36,5.36-12.35-3.26-10.48-4-14.91,2.33-10,1.4-13.74-1.63-2.33-2.33-7.92-.7-36.81-2.8-45.89-4.42-24.46-4.42-24.46.46-37,.46-38.21.47-14.44.47-14.44-17.71,4.89-32.38,1.17A245.14,245.14,0,0,1,622.76,272.94Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M594.87,234.07l.76-4.42,3.55,3.36S596.34,233.82,594.87,234.07Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M601.12,218.37l3,2.94a10.87,10.87,0,0,1,0,5.09c-.61,3.15-4.06,6.3-5,6.61l-1.83.61-3.22-4S599.9,227.11,601.12,218.37Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M617.05,178.53a63.66,63.66,0,0,0-3.51,14.68c-.64,7.19-4.63,30-4.63,30l-4.79-1.91s.64,3.51-2.07,8.14a8.91,8.91,0,0,1-7.18,4.62s8.62,9.1,11.49,11,4.63,2.71,6.86,1.91,6.07-8.46,6.39-8.94,1.75-56.34,1.43-57.93S617.05,178.53,617.05,178.53Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M615,226.74c-2-2.61-6.1-3.52-6.1-3.52a19.87,19.87,0,0,1,4.48,6.38",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M595.51,214.76s-4.15-3.51-6.55-3.83-6.22,1-9.58,1-5.58-1.92-6.06-.16,2.39,4.31,4,4.79,5.27,0,6.07,0a3.53,3.53,0,0,1,1.75.8s-1.69,4-2.17,4.66a12.54,12.54,0,0,1-2.66,1.78s-8.26-3.57-7.78-1.82,5.11,5.27,7.66,6.39,8.14,2.23,10.86,2.87,4.94,1.12,6.54-1.12,4.79-5.1,4.47-9.57A5.91,5.91,0,0,0,595.51,214.76Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M588.43,225.39a16.54,16.54,0,0,0-5-4.28c-2.77-1.34-5.47-1.34-4.6.4a40.43,40.43,0,0,0,5.07,6.42,9,9,0,0,0,3.25,2.53c1.27.56,2.54.16,2.38-1.58A10.46,10.46,0,0,0,588.43,225.39Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M590.49,225.63s-7.45-2.93-7.84-.71,1.9,2.06,4.67,4,4.75,2.37,5.63,2.29,1.18-1.58,1.18-1.58Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M597.14,227.21s-6.25-6.1-7-3.64,3.81,6.73,5.07,7.37,2.54-1.59,3.33-2.7",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M621,266.68v11.2s14.62,6.84,29.61,7.59,31.51-2.65,31.51-2.65l.19-100s-10.44-5.32-20.12-6.84-38.53,2.85-38.53,2.85Z",
    style: {
      fill: "#6C63FF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M644.19,159.54s-2.24,23-1.6,24.42a9.75,9.75,0,0,0,8.94,5.26c5.59,0,11.65-5.9,11.65-5.9l1.92-23.15s-7.35,3.52-12.45,2.4A32.89,32.89,0,0,1,644.19,159.54Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "651.8 168.56 664.3 176.5 665.29 158.65 651.8 168.56",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M639,140.22s-1.59-3.67-3.19-.8,3.67,10.22,3.67,10.22Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M669.62,140.22s1.59-3.67,3.19-.8-4.49,10.69-4.49,10.69Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M639.45,142.3s-1.6-5.75-1.6-7.35,2.88-1.59,2.88-1.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M639.67,134s-.56,19.77.93,22.94,6.71,10.44,8,11.37,5.78,1.31,7.09,1.12,11.3-10.16,11.67-11.46,1.94-19.5,1.94-19.5l-.18-15.1a18.39,18.39,0,0,0-9.33-1.68c-5.6.37-19.4,6.34-19.4,6.34Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M664.85,126.32s-4.67,6.16-6.72,7.09-1.68-3-1.68-3a32.54,32.54,0,0,1-11.75,5.23c-6.9,1.49-12.49,1.86-14.36-.75s4.1-6.34,4.1-6.34-4.66-2.8,0-7.83,16.6-10.64,25.18-7.28,6.9,6.53,6.9,6.53,6.53-.93,7.09,4.29-3.36,11.19-3.36,11.19-.18,4.48-.18,5.59-1.31.94-1.31.94l-.56-5.6s-2.05.19-3.17-3.73A10.7,10.7,0,0,1,664.85,126.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M649.35,152.67a7.06,7.06,0,0,0,3.67,1.6,6.64,6.64,0,0,0,3.51-1.44",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M647.43,156.82s3.51,1.92,6.55,1.6a7.87,7.87,0,0,0,4.94-2.87",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M656.53,138.63s6.06-1.76,8,1.59",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M650,139.1s-4.16-2.87-7.35.16",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M648.23,142.78c0,1.05-.47,1.91-1,1.91s-1-.86-1-1.91.47-1.92,1-1.92S648.23,141.72,648.23,142.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M660.28,142.78c0,1.05-.46,1.91-1,1.91s-1-.86-1-1.91.47-1.92,1-1.92S660.28,141.72,660.28,142.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M693.56,278.16s-2.69,5.12-3,6.46,0,5.92-.27,8.35-2.28,3.23-.94,4.3,3.5-1.07,4-2,1.21-2.82,1.88-4.3,1.48,1.21,1.89,2,.13,8.88.27,10.22-1.62,6.33-1.08,7.27,1.75.94,2.29-.4a41.87,41.87,0,0,1,2.15-4s7.13-5.92,7.8-6.86-2.82-13.73-3.09-15.88-.81-5.52-.81-5.52Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M700.83,306a36.81,36.81,0,0,0,1.88-5.11c.27-1.48.54-3.5.68-3.91",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M702.31,304.67s2.69-3,3-4.3.54-3,.54-3",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M693.35,274.14l.21,4s1.89,2,6.73,2.43,6.46-1.89,6.46-1.89l.32-3.45S696.36,275.36,693.35,274.14Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M664.3,168.63s-6.71,21.55-8.94,40.54-1.6,66.4-1.6,66.4,3.36,1.12,14.85,1,16.92-1.75,16.92-1.75L687,227.37l8.14,11.33-1.75,35.44s1.61,2.14,5.74,2.55a19.74,19.74,0,0,0,9.41-1.35s3.52-37,3.36-39.83-20.11-51.71-21.7-53.31-21.39-11.65-21.39-11.65S666.53,166.56,664.3,168.63Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M668.77,170.55s.48,5.11.48,11.65a103.49,103.49,0,0,1-1,13.09,13.81,13.81,0,0,0-7,.16c-3.52,1.12-4.31,2.39-4.31,2.39s4.94-26,7.34-29.21S667.49,167.84,668.77,170.55Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M687,227.37s-9.73-12.61-9.09-17.88,1.59-11,1.59-11",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M642.91,168.63s-1.91,25.22-3.67,37.51-.64,68.16-.64,68.16a66.87,66.87,0,0,1-12.93-2.72,91.72,91.72,0,0,1-9.57-3.67l.63-33.84s-1.27-53.94.32-55.54,20.43-7,20.43-7S641,168.15,642.91,168.63Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M637.48,171.51s-2.07,7.34-4,13.56a71.25,71.25,0,0,0-2.39,9.58,3.29,3.29,0,0,1,4.79-.64,42.82,42.82,0,0,1,4.63,3.83l2.7-29.19A6,6,0,0,0,637.48,171.51Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Arrow--inject-119"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M585.62,85.27l-7.37,3.37A83.12,83.12,0,0,0,424.47,122h13.1a70.13,70.13,0,0,1,128.77-28l-6.78,3.11a3.26,3.26,0,0,0-.54,5.63l23.35,16.61a3.27,3.27,0,0,0,5.15-2.35l2.71-28.53A3.27,3.27,0,0,0,585.62,85.27Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Device--inject-119"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M293.58,370.49s9.44,40.59,5.33,47.26c-5.37,8.72-62.59,14-62.59,14H362.49s15.81-4.43,11.06-17.15c-3.68-9.83-21.33-44.09-21.33-44.09Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.82,370.49s10.07,40.93,5.33,47.26-59.83,11.17-59.83,11.17H363.08s10.66-4.31,7.7-14.34-21.32-44.09-21.32-44.09Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.46,370.49H290.82s6,24.25,6.54,38.3h71.23C362.82,395.29,349.46,370.49,349.46,370.49Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 236.32,
    y: 429.12,
    width: 126.17,
    height: 2.61,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 134.09,
    y: 88.97,
    width: 380.69,
    height: 285.51,
    rx: 8.48,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 125.12,
    y: 88.97,
    width: 380.69,
    height: 285.51,
    rx: 8.48,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.12,330.11H505.8a0,0,0,0,1,0,0V366a8.48,8.48,0,0,1-8.48,8.48H133.6a8.48,8.48,0,0,1-8.48-8.48v-35.9a0,0,0,0,1,0,0Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.48,352.3a7,7,0,1,0-7,7A7,7,0,0,0,322.48,352.3Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 134.09,
    y: 97.46,
    width: 360.87,
    height: 224.61,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 488.13,
    y: 97.46,
    width: 6.83,
    height: 224.61,
    style: {
      fill: "#d1d1d1",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 488.13,
    y: 192.24,
    width: 6.83,
    height: 35.04,
    style: {
      fill: "#b0b0b0",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 134.09,
    y: 97.46,
    width: 360.87,
    height: 18.22,
    style: {
      fill: "#6C63FF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 147.2,
    y: 102.92,
    width: 260.37,
    height: 8.93,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 298.43,
    y: 147.27,
    width: 20.3,
    height: 5.89,
    style: {
      fill: "#b0b0b0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 341.98,
    y: 147.27,
    width: 20.3,
    height: 5.89,
    style: {
      fill: "#b0b0b0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 385.53,
    y: 147.27,
    width: 20.3,
    height: 5.89,
    style: {
      fill: "#b0b0b0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 429.07,
    y: 147.27,
    width: 20.3,
    height: 5.89,
    style: {
      fill: "#b0b0b0"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 145.85,
    y1: 165.61,
    x2: 476.55,
    y2: 165.61,
    style: {
      fill: "none",
      stroke: "#b0b0b0",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 161.57,
    cy: 143.34,
    r: 17.03,
    transform: "translate(-54.04 156.23) rotate(-45)",
    style: {
      fill: "#6C63FF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 144.54,
    y: 176.41,
    width: 332.66,
    height: 66.79,
    style: {
      fill: "#6C63FF"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 166.08,
    y1: 257.62,
    x2: 211.34,
    y2: 257.62,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 147.16,
    y1: 257.62,
    x2: 163,
    y2: 257.62,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 197.47,
    y1: 273.33,
    x2: 211.34,
    y2: 273.33,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 161.77,
    y1: 273.33,
    x2: 193.47,
    y2: 273.33,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 147.16,
    y1: 273.33,
    x2: 158.39,
    y2: 273.33,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 176.54,
    y1: 289.05,
    x2: 211.34,
    y2: 289.05,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 147.16,
    y1: 289.05,
    x2: 172.85,
    y2: 289.05,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 199,
    y1: 304.77,
    x2: 211.34,
    y2: 304.77,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 155.31,
    y1: 304.77,
    x2: 195.93,
    y2: 304.77,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 147.16,
    y1: 304.77,
    x2: 151.93,
    y2: 304.77,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 353.88,
    y1: 257.62,
    x2: 399.13,
    y2: 257.62,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 334.96,
    y1: 257.62,
    x2: 350.8,
    y2: 257.62,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 385.26,
    y1: 273.33,
    x2: 399.13,
    y2: 273.33,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 349.57,
    y1: 273.33,
    x2: 381.26,
    y2: 273.33,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 334.96,
    y1: 273.33,
    x2: 346.19,
    y2: 273.33,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 364.34,
    y1: 289.05,
    x2: 399.13,
    y2: 289.05,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 334.96,
    y1: 289.05,
    x2: 360.65,
    y2: 289.05,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 386.8,
    y1: 304.77,
    x2: 399.13,
    y2: 304.77,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 343.11,
    y1: 304.77,
    x2: 383.73,
    y2: 304.77,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 334.96,
    y1: 304.77,
    x2: 339.72,
    y2: 304.77,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 429.67,
    y1: 257.62,
    x2: 474.92,
    y2: 257.62,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 410.75,
    y1: 257.62,
    x2: 426.59,
    y2: 257.62,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 461.05,
    y1: 273.33,
    x2: 474.92,
    y2: 273.33,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 425.36,
    y1: 273.33,
    x2: 457.05,
    y2: 273.33,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 410.75,
    y1: 273.33,
    x2: 421.97,
    y2: 273.33,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 440.13,
    y1: 289.05,
    x2: 474.92,
    y2: 289.05,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 410.75,
    y1: 289.05,
    x2: 436.43,
    y2: 289.05,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 462.59,
    y1: 304.77,
    x2: 474.92,
    y2: 304.77,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 418.9,
    y1: 304.77,
    x2: 459.51,
    y2: 304.77,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 410.75,
    y1: 304.77,
    x2: 415.51,
    y2: 304.77,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 220.2,
    y: 254.08,
    width: 106.99,
    height: 53.5,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "220.2 307.58 257.54 286.4 276.49 291.98 306.02 268.57 326.64 281.94 326.64 307.58 220.2 307.58",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 240.26,
    cy: 271.36,
    r: 8.36,
    transform: "translate(-122.1 264.01) rotate(-47.32)",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Window--inject-119"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M549.33,125.18H616.5a6.06,6.06,0,0,1,6.06,6.06v74.48a0,0,0,0,1,0,0H543.27a0,0,0,0,1,0,0V131.24A6.06,6.06,0,0,1,549.33,125.18Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M549.33,125.18H616.5a6.06,6.06,0,0,1,6.06,6.06v4.47a0,0,0,0,1,0,0H543.27a0,0,0,0,1,0,0v-4.47A6.06,6.06,0,0,1,549.33,125.18Z",
    style: {
      fill: "#6C63FF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M562.23,148.12a6.24,6.24,0,1,1-6.24-6.25A6.24,6.24,0,0,1,562.23,148.12Z",
    style: {
      fill: "#6C63FF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 549.74,
    y: 161.76,
    width: 9.82,
    height: 2.85,
    style: {
      fill: "#b0b0b0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 549.74,
    y: 172.11,
    width: 9.82,
    height: 2.85,
    style: {
      fill: "#b0b0b0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 549.74,
    y: 182.45,
    width: 9.82,
    height: 2.85,
    style: {
      fill: "#b0b0b0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 549.74,
    y: 192.68,
    width: 9.82,
    height: 2.85,
    style: {
      fill: "#b0b0b0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 568.03,
    y: 140.54,
    width: 48.61,
    height: 16.05,
    style: {
      fill: "#6C63FF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 569.11,
    y: 160.75,
    width: 45.2,
    height: 22.6,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "569.11 183.34 584.88 174.4 592.89 176.75 605.36 166.87 614.07 172.52 614.07 183.34 569.11 183.34",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 577.58,
    cy: 168.04,
    r: 3.53,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 582.65,
    y1: 188.15,
    x2: 616.31,
    y2: 188.15,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 568.58,
    y1: 188.15,
    x2: 580.36,
    y2: 188.15,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 606,
    y1: 192.65,
    x2: 616.31,
    y2: 192.65,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 579.45,
    y1: 192.65,
    x2: 603.02,
    y2: 192.65,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 568.58,
    y1: 192.65,
    x2: 576.93,
    y2: 192.65,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 590.43,
    y1: 197.14,
    x2: 616.31,
    y2: 197.14,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 568.58,
    y1: 197.14,
    x2: 587.69,
    y2: 197.14,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 607.14,
    y1: 201.63,
    x2: 616.31,
    y2: 201.63,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 574.64,
    y1: 201.63,
    x2: 604.85,
    y2: 201.63,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 568.58,
    y1: 201.63,
    x2: 572.13,
    y2: 201.63,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDevWeb);
export default __webpack_public_path__ + "static/media/devWeb.457e1207d3a1d26ae1a308f69500b471.svg";
export { ForwardRef as ReactComponent };